import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    requestAnimationFrame(() => {
      this.showToast()
    })

    this.autoDismissTimeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    clearTimeout(this.autoDismissTimeout)
  }

  showToast() {
    this.containerTarget.classList.add("translate-y-0", "opacity-100")
  }

  dismiss() {
    this.containerTarget.classList.remove("translate-y-0", "opacity-100")
    this.containerTarget.classList.add("-translate-y-4", "opacity-0")

    this.dismissTimeout = setTimeout(() => {
      this.element.remove()
    }, 500)
  }
}
